// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dResult from "../Data.Result/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Restaumatic$dFOD$dTypes$dClaimFODError from "../Restaumatic.FOD.Types.ClaimFODError/index.js";
import * as Unscramble from "../Unscramble/index.js";
const ClaimFODResult = x => x;
const newtypeClaimFODResult_ = {Coercible0: () => {}};
const eqClaimFODResult = {
  eq: x => y => {
    const $0 = Data$dEq.eqArrayImpl(Restaumatic$dFOD$dTypes$dClaimFODError.eqClaimFODError.eq);
    if (x.tag === "Left") {
      if (y.tag === "Left") { return $0(x._1)(y._1); }
      return false;
    }
    if (x.tag === "Right") {
      if (y.tag === "Right") { return x._1 === y._1; }
      return false;
    }
    return false;
  }
};
const genericClaimFODResult = {to: x => x, from: x => x};
const showClaimFODResult = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dFOD$dTypes$dClaimFODError.showClaimFODError.show);
      return {
        genericShowArgs: v => [
          (() => {
            if (v.tag === "Left") { return "(Left " + $0(v._1) + ")"; }
            if (v.tag === "Right") {
              if (v._1) { return "(Right true)"; }
              return "(Right false)";
            }
            $runtime.fail();
          })()
        ]
      };
    })())({reflectSymbol: () => "ClaimFODResult"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeClaimFODResult = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Data$dResult.udecodeResult({unsafeDecode: Unscramble.decodeArray(Restaumatic$dFOD$dTypes$dClaimFODError.unscrambleDecodeClaimFODError.unsafeDecode)})(Unscramble.decodeBoolean1);
    return x => $0.unsafeDecode(x);
  })()
};
const encodeClaimFODResult = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericClaimFODResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "ClaimFODResult"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dFunctor.arrayMap(Restaumatic$dFOD$dTypes$dClaimFODError.encodeClaimFODError.encode);
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg(
          "PlainArg",
          (() => {
            if (v.tag === "Left") { return {Left: $0(v._1)}; }
            if (v.tag === "Right") { return {Right: v._1}; }
            $runtime.fail();
          })()
        ),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeClaimFODResult = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericClaimFODResult)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "ClaimFODResult"
  })(/* #__PURE__ */ (() => {
    const $0 = Data$dResult.decodeResult(Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dFOD$dTypes$dClaimFODError.decodeClaimFODError))(Foreign$dGeneric$dClass.booleanDecode);
    return {decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => $0.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing};
  })())(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  ClaimFODResult,
  decodeClaimFODResult,
  encodeClaimFODResult,
  eqClaimFODResult,
  genericClaimFODResult,
  newtypeClaimFODResult_,
  showClaimFODResult,
  unscrambleDecodeClaimFODResult
};
